module.exports = { 
  CCPL_API_URL : "https://ccpl.ninjaos.com/api/",
  MARS_API_URL : "https://mars.ninjaos.com/api/",
  JUPITER_URL : "https://jupiter.ninjaos.com/api/",
  LOCAL_URL    : "",
  LOGO_URL     : "media/dev_team/company-logo/"
 }